import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditProductModalData {
  product: {
    id: string | number;
    name?: string;
    displayName?: string;
    description?: string;
    displayDescription?: string;
    price?: string;
    sku?: string;
    imageUrl?: string;
  };
  showDescription?: boolean;
}

export interface EditProductModalResult {
  displayName?: string;
  displayDescription?: string;
}

@Component({
  selector: 'edit-product-modal',
  templateUrl: './edit-product-modal.component.html',
  styleUrls: ['./edit-product-modal.component.scss'],
  standalone: false,
})
export class EditProductModalComponent {
  displayName: string;
  displayDescription: string;
  showDescription: boolean;

  constructor(
    public dialogRef: MatDialogRef<EditProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditProductModalData,
  ) {
    this.displayName = data.product.displayName || '';
    this.displayDescription = data.product.displayDescription || '';
    this.showDescription = data.showDescription !== false;
  }

  get originalName(): string {
    return this.data.product.name || '';
  }

  get originalDescription(): string {
    return this.data.product.description || '';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const result: EditProductModalResult = {
      displayName: this.displayName.trim() || undefined,
      displayDescription: this.displayDescription.trim() || undefined,
    };
    this.dialogRef.close(result);
  }

  onClearName(): void {
    this.displayName = '';
  }

  onClearDescription(): void {
    this.displayDescription = '';
  }
}
